if (!customElements.get('promo-countdown-timer')) {
  class PromoCountdownTimer extends HTMLElement {
    constructor() {
      super();
      this.timerInterval = null;
      this._serverEndMs = null;
      this._pageLoadTimeMs = Date.now();
      this._useServerTime = true;
      this._endedFired = false;
    }

    connectedCallback() {
      const serverEndAttr = this.dataset.serverEnd;
      if (serverEndAttr) {
        const serverEndSec = Number(serverEndAttr);
        if (!Number.isNaN(serverEndSec)) {
          this._serverEndMs = serverEndSec * 1000;
        }
      }

      const useServerAttr = this.dataset.useServerTime;
      if (useServerAttr === undefined || useServerAttr === null || String(useServerAttr) === '') {
        this._useServerTime = true;
      } else {
        this._useServerTime = String(useServerAttr).toLowerCase() === 'true';
      }

      this.startTimer();
    }

    disconnectedCallback() {
      if (this.timerInterval) clearInterval(this.timerInterval);
    }

    getEndTime() {
      const isRepeat = String(this.dataset.repeat || '').toLowerCase() === 'true';

      if (isRepeat && this._serverEndMs && this._useServerTime) {
        const now = Date.now();
        const millisecondsElapsed = now - this._pageLoadTimeMs;
        const secondsRemainingToday =
          Math.floor((this._serverEndMs - this._pageLoadTimeMs) / 1000) -
          Math.floor(millisecondsElapsed / 1000);

        if (secondsRemainingToday <= 0) {
          const clientNow = new Date();
          return new Date(
            clientNow.getFullYear(),
            clientNow.getMonth(),
            clientNow.getDate(),
            23,
            59,
            59,
            999
          ).getTime();
        }

        return this._serverEndMs;
      }

      if (isRepeat) {
        const now = new Date();
        return new Date(
          now.getFullYear(),
          now.getMonth(),
          now.getDate(),
          23,
          59,
          59,
          999
        ).getTime();
      }

      const endAttr = this.dataset.end;
      if (endAttr) {
        // Support "YYYY-MM-DD HH:MM:SS" by normalizing to ISO-ish for Safari
        const normalized = endAttr.trim().replace(' ', 'T');
        const parsed = Date.parse(normalized);
        if (!Number.isNaN(parsed)) return parsed;
      }

      return Date.now();
    }

    startTimer() {
      const hoursEl = this.querySelector('[data-hours]');
      const minsEl = this.querySelector('[data-mins]');
      const secsEl = this.querySelector('[data-secs]');
      const isRepeat = String(this.dataset.repeat || '').toLowerCase() === 'true';

      const updateUI = () => {
        const endTime = this.getEndTime();
        const timeLeft = Math.max(0, Math.floor((endTime - Date.now()) / 1000));
        const h = Math.floor(timeLeft / 3600);
        const m = Math.floor((timeLeft % 3600) / 60);
        const s = timeLeft % 60;

        if (hoursEl) hoursEl.textContent = String(h).padStart(2, '0');
        if (minsEl) minsEl.textContent = String(m).padStart(2, '0');
        if (secsEl) secsEl.textContent = String(s).padStart(2, '0');

        if (timeLeft <= 0 && !isRepeat && !this._endedFired) {
          this._endedFired = true;
          clearInterval(this.timerInterval);
          this.dispatchEvent(new CustomEvent('promo-countdown:ended', { bubbles: true }));
        }
      };

      updateUI();
      if (this.timerInterval) clearInterval(this.timerInterval);
      this.timerInterval = setInterval(updateUI, 1000);
    }
  }

  customElements.define('promo-countdown-timer', PromoCountdownTimer);
}
